import React from "react";

import Seat from "@busbud/design-system-components/dist/Seat";
import type { SeatBaseState } from "@busbud/design-system-components/dist/SeatBase";
import Stack from "@busbud/design-system-components/dist/Stack";
import type * as UDM from "@busbud/int-schemas/udm";

import { createArrayOfLength } from "@app/utils/array";

interface Props {
  passengers_count: number;
  selected_seats: UDM.SeatCell[];
}

function getSeatState(selected_seat: UDM.SeatCell): SeatBaseState {
  switch (selected_seat.gender) {
    case "any":
    case null:
      return "selected";
    case "female":
      return "unavailableWoman";
    default:
      return "unavailableMan";
  }
}

export const Seats: React.FC<Props> = ({
  selected_seats,
  passengers_count
}) => {
  return (
    <Stack spacing={1}>
      {selected_seats.map(selected_seat => (
        <Seat
          key={selected_seat.id}
          state={getSeatState(selected_seat)}
          seatNumber={selected_seat.display_name}
          size="md"
        />
      ))}
      {createArrayOfLength(passengers_count - selected_seats.length).map(
        (_, index) => (
          <Seat key={`unselected-${index}`} state="selected" size="md" />
        )
      )}
    </Stack>
  );
};
